import { Mailbox } from 'lucide-react';
import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/Card';
const RecentMessages = ({ recentMessages }) => {
    return (
        <Card className="shadow-elegant">
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <Mailbox className="h-5 w-5 text-primary" />
                    Son Mesajlar
                </CardTitle>
                <CardDescription>Müşterilerden gelen son mesajlar</CardDescription>
            </CardHeader>
            <CardContent>

                <div className="divide-y divide-gray-200 overflow-y-auto max-h-72">
                    {recentMessages.slice(0, 2).map((msg) => (
                        <div key={msg._id} className="py-3">
                            <p className="font-medium">{msg.name}</p>
                            <p className="text-sm text-gray-600">{msg.message}</p>
                            <p className="text-xs text-gray-400">
                                {new Date(msg.createdAt).toLocaleDateString("tr-TR", {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                })}
                            </p>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    )
}

export default RecentMessages